import React, { useMemo } from 'react';
import clsx from 'clsx';
import { CarIcon } from '../../icons';

const CarCard = ({
  className,
  cardRef,
  carData,
  selectedCar,
  isAssignedView = false,
  handleCardClick,
  isUsedInDocumentsSection,
}) => {
  const { plateno, title, subTitle, info, isNewCar } = carData;
  const isSelected = useMemo(() => {
    return plateno && selectedCar?.plateno === plateno;
  }, [selectedCar?.plateno, plateno]);

  return (
    <li
      ref={cardRef}
      className={clsx(
        `p-3 flex w-full items-center justify-between gap-3 rounded-lg h-fit ${
          isSelected ? 'bg-[#282828] text-white' : ' bg-white'
        }`,
        className
      )}
      role={handleCardClick && 'button'}
      onClick={handleCardClick && handleCardClick}
      key={plateno}
    >
      <div className={`flex items-center justify-center gap-2 ${isUsedInDocumentsSection && "max-md:hidden"}`}>
        {isAssignedView ? (
          <div className="rounded-full bg-powdergrey p-3">
            <CarIcon color={isSelected ? 'white' : 'black'} />
          </div>
        ) : (
          <CarIcon color={isSelected ? 'white' : 'black'} className={`${isUsedInDocumentsSection && "max-lg:hidden"}`}/>
        )}
        <div className="flex flex-col gap-1">
          <div className="text-body truncate max-xl:w-[60px]" title={title}>
            {title}
          </div>
          <p className="text-disclaimer truncate max-xl:w-[60px]" title={subTitle}>
            {subTitle}
          </p>
        </div>
      </div>
      <div>
        <h6 className={`${isSelected ? 'white' : 'text-black'}`} title={info}>
          {info}
        </h6>
        {isNewCar && <p className='text-sm text-end text-primary font-[700]'>ΝΕΟ</p>}
      </div>
    </li>
  );
};

export default CarCard;
